export default __webpack_public_path__ + "static/media/04.9cdc8193.webp";